import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../services/common.service';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { FormPopupComponent } from '../form-popup/form-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'calsoft-bannertextwithimage',
  imports: [CustomFlexLayoutModule, EditorTextComponent],
  templateUrl: './bannertextwithimage.component.html',
  styleUrl: './bannertextwithimage.component.scss'
})
export class BannertextwithimageComponent {

    @Input() item: any;
  @Input() img: any;
  @Input() data : any;
  @Input() categoryId6: any;

  @Input() navigation: any;
  @Input() catId: any;

  @Input() navigatedUrl: any;

  public serverPath = environment.commonImageApi + '/home/';

  public serverPath1 = environment.commonImageApi + '/commonSlider/';
  
  constructor( private commonService: CommonService,
      public dialog: MatDialog,
  ) { }

  goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }
  

  link(url: any) {

    this.commonService.goToLink(url)
  }

  openInNewWindow(url: string) {
    if (url) {
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }

  dynamicFormPopup(formGroupId:any) {
    if (window.innerWidth > 768) {

       let dialogRef = this.dialog.open(FormPopupComponent, {
          width: '790px',
          data: { formId: formGroupId}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(() => {

       });

    }
    else {
       let dialogRef = this.dialog.open(FormPopupComponent, {
          minWidth: '100vw', height: '100vh',
          data: { formId: formGroupId}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(() => {

       });
    }

 }

}
